import useLocalStorageState from 'App/hooks/useLocalStorageState'

export default function useCookiesAccepted() {
  const [prompCookies] = useLocalStorageState('prompCookies', null)
  if (!prompCookies) return false
  return JSON.parse(prompCookies).userClickAccepted
}
